import { createFileRoute, useParams } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { SettingsPageHeader } from '@/components/ui';
import { BusinessSetupPageShell } from './business-setup/components/business-setup-page-shell';
import { PhoneNumbersPageContent } from './business-setup/phone-numbers/phone-numbers-page-content';
import { formatDocumentTitle } from '@/lib/document-title';

export const Route = createFileRoute('/_auth/$orgId/settings/business-setup/phone-numbers')({
  component: PhoneNumbersPage,
});

function PhoneNumbersPage() {
  const { orgId } = useParams({ from: '/_auth/$orgId/settings/business-setup/phone-numbers' });

  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Phone Numbers')}</title>
      </Helmet>

      <BusinessSetupPageShell orgId={orgId} activePath="phone-numbers">
        <SettingsPageHeader
          title="Phone Numbers"
          description="Manage your Hayven Number and its carrier verification for client messaging."
        />
        <PhoneNumbersPageContent orgId={orgId} />
      </BusinessSetupPageShell>
    </>
  );
}
